import {useCallback, useMemo, useRef} from 'react';
import * as React from "react";

import {Marker, MarkerProps, useMap, useMapEvent, useMapEvents} from "react-leaflet";
import * as L from "leaflet";
import * as CurrentPositionIcon from '../../assets/_img/marker.svg';
import * as MarkerShadow from '../../assets/img/marker-shadow.png';

import {GeoProps} from "../services/SearchService";
import {latLongType} from "./App";
import {map} from "leaflet";
interface Props {
    geo: GeoProps;
    onChangeGeo: (latlng: latLongType) => void;
}
const CurrentPositionMarker:React.FC<Props> = (props) => {
    const map = useMap();
    const markerRef = useRef(null);
    const htmlIcon = `<span><img src="${ CurrentPositionIcon }" /></span>`;

    const mapClickHandler = useCallback((e: any) => {
        props.onChangeGeo([e.latlng.lat, e.latlng.lng])
    }, [])

    useMapEvent('click', mapClickHandler)
    const eventHandlers = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current
                if (marker != null) {
                    props.onChangeGeo([marker.getLatLng().lat, marker.getLatLng().lng])
                }
                setTimeout(function() {
                    map.on('click', mapClickHandler);
                }, 10);
            },
            dragstart(e: any) {
                map.off("click", mapClickHandler)
            },
        }),
        [],
    )
    const currentPositionIcon = L.divIcon({
        iconSize: [ 32, 48 ],
        iconAnchor: [ 16, 35 ],
        popupAnchor: [ 2, -40 ],
        // @ts-ignore
        iconUrl: CurrentPositionIcon,
        // @ts-ignore
        shadowUrl: MarkerShadow,
        className: 'current-position-icon',
        html: htmlIcon
    });

    return (
        <>
            {props.geo.lat !== undefined &&  props.geo.lng !== undefined &&
                <Marker
                    ref={markerRef}
                    icon={currentPositionIcon}
                    position={[props.geo.lat, props.geo.lng]}
                    eventHandlers={eventHandlers}
                    draggable={true}
                >
                </Marker>
            }
        </>
    );
};

export default CurrentPositionMarker;
